export const useDefaultData = ({ Helpers }) => {

    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idmanagement: '',
        idmanagementtypes: '',
        idlawyer: '',
        process_number: '',
        gestion_fecha: getCurrentDate(),
        gestion_usuario: '',
        gestion_descripcion: '',
        info_descuento: '',
        aprobacion_check: '',
        aprobacion_usuario: '',
        aprobacion_fecha: '',
        aprobacion_observaciones: '',
        infoProcessLawyer: []
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}